import React from 'react';
import { withRouter } from 'react-router';
import queryString from 'qs';

const TabPanel = (props) => {
  const options = {
    ignoreQueryPrefix: true,
  };
  const qs = props.TypeExists
    ? queryString.parse(props.location.search, options)
    : '';

  if ((props.default && !qs.t) || qs.t === props.id)
    return <div className="c-tab-panel">{props.children}</div>;

  return null;
};

export default withRouter(TabPanel);
